import { Injectable } from "@angular/core";
import { of, Observable } from "rxjs";
import { ITimer } from "@interfaces/timer";

@Injectable({
  providedIn: "root",
})
export class TimerService {
  ITimer: ITimer = { days: null, hours: null, mins: null, secs: null };

  countDownTime(countDownDate): Observable<ITimer> {
  try {
    if (this.checkIfCountDownExpire(this.ITimer)) {
      return of(this.ITimer);
    }
    let millisecondsNow = new Date().getTime();
    let countDown = new Date(countDownDate).getTime();
    if (countDown >= millisecondsNow) {
      if (!countDownDate) {
        return of(null);
      }
      if (typeof countDownDate === "string") {
        countDownDate = new Date(countDownDate);
      }

      let delta = Math.floor((millisecondsNow - countDownDate.getTime()) / 1000);
      if (delta < 0) {
        delta = Math.abs(delta);
      }

      let dayCal = Math.floor(delta / 86400);
      delta %= 86400;
      let hourCal = Math.floor(delta / 3600);
      delta %= 3600;
      let minuteCal = Math.floor(delta / 60);
      delta %= 60;
      let secondsCal = Math.floor(delta);

      this.ITimer.days = dayCal <= 9 ? "0" + dayCal : dayCal;
      this.ITimer.hours = hourCal <= 9 ? "0" + hourCal : hourCal;
      this.ITimer.mins = minuteCal <= 9 ? "0" + minuteCal : minuteCal;
      this.ITimer.secs = secondsCal <= 9 ? "0" + secondsCal : secondsCal;
    } else {
      this.ITimer.days = "00";
      this.ITimer.hours = "00";
      this.ITimer.mins = "00";
      this.ITimer.secs = "00";
    }
        return of(this.ITimer);
  } catch (error) {
    return error;
  }
  }

  multipleTimers(products): Observable<ITimer[]> {
    let resultDate = [];
    for (let i = 0; i < products?.length; i++) {
      if (products[i]?.offer_id) {
        let productCountDown: any = products[i].jackpotDetails.countDown
          ? products[i].jackpotDetails.countdown
          : products[i].jackpotDetails.draw_countdown
          ? products[i].jackpotDetails.draw_countdown
          : products[i].jackpotDetails.expiry_date;

        let now = new Date().getTime();
        let countDown =
          typeof productCountDown === "object"
            ? productCountDown.toDate().getTime()
            : new Date(productCountDown).getTime();
        if (countDown >= now) {
          if (!productCountDown) {
            return of(null);
          }
          if (typeof productCountDown === "string") {
            productCountDown = new Date(productCountDown);
          } else if (typeof productCountDown === "object") {
            productCountDown = productCountDown.toDate();
          }
          let delta = Math.floor((now - productCountDown.getTime()) / 1000);
          if (delta < 0) {
            delta = Math.abs(delta);
          }
          let day = Math.floor(delta / 86400);
          delta %= 86400;
          let hour = Math.floor(delta / 3600);
          delta %= 3600;
          let minute = Math.floor(delta / 60);
          delta %= 60;
          let seconds = Math.floor(delta);
          let timer = { days: null, hours: null, mins: null, secs: null };
          timer.days = day <= 9 ? "0" + day : day;
          timer.hours = hour <= 9 ? "0" + hour : hour;
          timer.mins = minute <= 9 ? "0" + minute : minute;
          timer.secs = seconds <= 9 ? "0" + seconds : seconds;
          resultDate.push(timer);
        } else {
          resultDate.push({ days: "00", hours: "00", mins: "00", secs: "00" });
        }
      } else {
        let productCountDown: any = products[i].countdown
          ? products[i].countdown
          : products[i].draw_countdown
          ? products[i].draw_countdown
          : products[i].expiry_date;

        let now = new Date().getTime();
        let countDown =
          typeof productCountDown === "object"
            ? productCountDown.toDate().getTime()
            : new Date(productCountDown).getTime();
        if (countDown >= now) {
          if (!productCountDown) {
            return of(null);
          }
          if (typeof productCountDown === "string") {
            productCountDown = new Date(productCountDown);
          } else if (typeof productCountDown === "object") {
            productCountDown = productCountDown.toDate();
          }
          let delta = Math.floor((now - productCountDown.getTime()) / 1000);
          if (delta < 0) {
            delta = Math.abs(delta);
          }
          let day = Math.floor(delta / 86400);
          delta %= 86400;
          let hour = Math.floor(delta / 3600);
          delta %= 3600;
          let minute = Math.floor(delta / 60);
          delta %= 60;
          let seconds = Math.floor(delta);
          let timer = { days: null, hours: null, mins: null, secs: null };
          timer.days = day <= 9 ? "0" + day : day;
          timer.hours = hour <= 9 ? "0" + hour : hour;
          timer.mins = minute <= 9 ? "0" + minute : minute;
          timer.secs = seconds <= 9 ? "0" + seconds : seconds;
          resultDate.push(timer);
        } else {
          resultDate.push({ days: "00", hours: "00", mins: "00", secs: "00" });
        }
      }
    }
        return of(resultDate);
  }

  private checkIfCountDownExpire(timer: ITimer) {
        return parseInt(timer.days) === 0 &&
      parseInt(timer.hours) === 0 &&
      parseInt(timer.mins) === 0 &&
      parseInt(timer.secs) === 0
      ? true
      : false;
  }
}
